import { QueryKeys } from '../queryKeys';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppDataContext } from '../../contexts/appData';

export const useGetFlashSalesData = ({ enabled }) => {
  const { api } = useContext(AppDataContext);

  const { data, refetch, isLoading, isPending, isFetching } = useQuery({
    queryKey: [QueryKeys.FlashSalesData],
    queryFn: () => api.getFlashSales(),
    staleTime: 1000 * 60 * 60,
    enabled,
    placeholderData: (previousData) => previousData,
  });

  const flashSaleData = data?.data;

  return { flashSaleData: flashSaleData && Object.keys(flashSaleData).length !== 0 ? flashSaleData : null };
};
